/* Yahyah B store attribution. No MSS secret or PostHog SDK belongs here. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document && root.YahyahMSSConfig) api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var FIELDS = ['partner_click_id', 'utm_source', 'utm_medium', 'utm_campaign',
    'utm_content', 'utm_term', 'portrait_id', 'fbclid',
    'meta_campaign_id', 'meta_adset_id', 'meta_ad_id', 'placement'];
  var STORE = 'z1gafm-0z.myshopify.com';
  // Shopify serves B on both its canonical myshopify hostname and the production custom domain.
  var HOSTS = { 'z1gafm-0z.myshopify.com': true, 'storelaunch.yahyah.ai': true };
  var VARIANT = '52615749075224';
  var KEY = 'yahyah_mss_test_v1';
  var TTL = 30 * 60 * 1000; // Fixed attribution window within one browser tab.

  function clean(search) {
    var params = new URLSearchParams(search), values = {}, touched = false, invalid = false;
    FIELDS.forEach(function (key) {
      if (!params.has(key)) return;
      touched = true;
      var all = params.getAll(key), value = all[0], limit = key === 'fbclid' ? 1024 : 255;
      if (all.length !== 1 || !value || value.length > limit || /[\u0000-\u001f\u007f]/.test(value)) {
        invalid = true; return;
      }
      if ((key === 'partner_click_id' || key === 'portrait_id') && !/^[A-Za-z0-9._:-]+$/.test(value)) {
        invalid = true; return;
      }
      values[key] = value; // Never trim, truncate, manufacture, or rewrite an identifier.
    });
    return { values: values, touched: touched, invalid: invalid };
  }

  function resolve(previous, incoming, now) {
    var prior = previous && previous.values && typeof previous.values === 'object' &&
      Number.isFinite(previous.expires_at) && Number.isFinite(previous.captured_at) && previous.expires_at > now && previous.captured_at <= now &&
      previous.expires_at - previous.captured_at <= TTL ? previous : null;
    if (incoming.invalid) return { values: {}, captured_at: now, expires_at: now + TTL, status: 'invalid_parameters' };
    if (!incoming.touched) return prior;
    // A new explicit source replaces the ENTIRE snapshot, preventing mixed campaigns.
    if (prior && incoming.values.partner_click_id && incoming.values.partner_click_id === prior.values.partner_click_id) return prior;
    return { values: incoming.values, captured_at: now, expires_at: now + TTL, status: 'last_touch_30m' };
  }

  function attributes(record, status) {
    var out = {};
    FIELDS.forEach(function (key) { out['__mss_' + key] = record && record.values[key] || ''; });
    out.__mss_attribution_status = status || (record ? record.status : 'no_attribution');
    out.__mss_captured_at = record ? new Date(record.captured_at).toISOString() : '';
    out.__mss_expires_at = record ? new Date(record.expires_at).toISOString() : '';
    out.__mss_test_environment = ''; // Clear the legacy marker; only Shopify payment facts determine test mode.
    return out;
  }

  function install(w) {
    if (w.YahyahMSS) return w.YahyahMSS;
    var config = w.YahyahMSSConfig;
    if (!HOSTS[w.location.hostname] || config.store !== STORE || String(config.variant) !== VARIANT) return null;
    var d = w.document, record = null, allowed = false, busy = false, viewCreated = false;
    var storageOK = true, entry = clean(w.location.search), ready;
    var rootPath = /^\/(?:[a-zA-Z-]+\/)?$/.test(config.root || '') ? config.root : '/';
    var status = 'waiting_for_consent', readyResolve;
    ready = new Promise(function (done) { readyResolve = done; });

    function storageRead(key) { try { return JSON.parse(w.sessionStorage.getItem(key)); } catch (_) { storageOK = false; return null; } }
    function storageWrite(key, value) { try { if (value) w.sessionStorage.setItem(key, JSON.stringify(value)); else w.sessionStorage.removeItem(key); } catch (_) { storageOK = false; } }
    function setStatus(value) {
      status = value;
      d.querySelectorAll('[data-mss-status]').forEach(function (node) {
        node.textContent = value === 'attribution_ready' ? 'Your privacy preferences have been saved.' :
          value === 'storage_unavailable' ? 'Your browser could not save your preferences.' :
          value === 'invalid_parameters' ? 'This referral link is invalid. You can still place an order.' :
          value === 'consent_unavailable' ? 'Optional analytics are unavailable. You can still place an order.' :
          'Optional analytics are off. You can still place an order.';
      });
    }
    function privacy() { return w.Shopify && w.Shopify.customerPrivacy; }
    function refreshConsent() {
      var p = privacy();
      allowed = !!(p && p.analyticsProcessingAllowed() && p.marketingAllowed());
      if (!allowed) {
        record = null; storageWrite(KEY, null); storageWrite(KEY + '_views', null);
        setStatus(p ? 'consent_not_granted' : 'consent_unavailable'); readyResolve(); return;
      }
      var previous = storageRead(KEY);
      // Do not trust a stored object's arbitrary keys; normalize its parameter snapshot again.
      if (previous && previous.values) {
        var validated = clean(new URLSearchParams(previous.values).toString());
        previous = validated.invalid ? null : Object.assign({}, previous, { values: validated.values });
      }
      record = resolve(previous, entry, Date.now());
      storageWrite(KEY, record);
      setStatus(storageOK ? (record && record.status === 'invalid_parameters' ? 'invalid_parameters' : 'attribution_ready') : 'storage_unavailable');
      readyResolve(); createView();
    }
    function currentRecord() {
      if (!allowed || !record || record.expires_at <= Date.now()) {
        record = null; storageWrite(KEY, null); return null;
      }
      return record;
    }
    async function request(path, body, retries) {
      for (var attempt = 0; ; attempt++) {
        var controller = new AbortController(), timer = w.setTimeout(function () { controller.abort(); }, 8000);
        try {
          var response = await w.fetch(rootPath + path, {
            method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: body ? JSON.stringify(body) : undefined, signal: controller.signal
          });
          var data = await response.json();
          if (!response.ok) throw new Error('Shopify cart request failed (' + response.status + '). Please retry.');
          return data;
        } catch (error) { if (attempt >= retries) throw error; }
        finally { w.clearTimeout(timer); }
        await new Promise(function (done) { w.setTimeout(done, 350); });
      }
    }
    async function sync() {
      await ready;
      var p = privacy();
      if (!p || !p.analyticsProcessingAllowed() || !p.marketingAllowed()) {
        allowed = false; record = null; storageWrite(KEY, null);
      }
      var current = currentRecord();
      await request('cart/update.js', { attributes: attributes(current, !allowed ? 'consent_not_granted' : undefined) }, 1);
    }
    async function checkout(form) {
      if (busy) throw new Error('Your checkout is already being prepared.');
      var values = new w.FormData(form), id = String(values.get('id') || VARIANT);
      var quantity = Number(values.get('quantity') || 1);
      if (id !== VARIANT || !Number.isInteger(quantity) || quantity < 1 || quantity > 99) throw new Error('Invalid product or quantity.');
      busy = true;
      try {
        await sync(); // Both purchase buttons wait for attribution before any checkout redirect.
        var cart = await request('cart.js', null, 1);
        if (cart.items.some(function (item) { return String(item.variant_id) !== VARIANT; })) throw new Error('Please remove other products from your cart first.');
        if (cart.items.length > 1) throw new Error('Please combine this product into one cart line.');
        if (cart.items.length) await request('cart/change.js', { id: cart.items[0].key, quantity: quantity }, 1);
        else {
          // Never blindly retry a non-idempotent add; re-read the cart after an ambiguous result.
          try { await request('cart/add.js', { items: [{ id: Number(VARIANT), quantity: quantity }] }, 0); }
          catch (error) {
            var recovered = await request('cart.js', null, 1);
            if (recovered.items.length !== 1 || String(recovered.items[0].variant_id) !== VARIANT || recovered.items[0].quantity !== quantity) throw error;
          }
        }
        var verified = await request('cart.js', null, 1);
        if (verified.items.length !== 1 || String(verified.items[0].variant_id) !== VARIANT || verified.items[0].quantity !== quantity || verified.currency !== 'USD' || verified.total_price !== quantity * 1000) throw new Error('The deposit must be USD 10 per item. Please review your cart.');
        w.location.assign(rootPath + 'checkout');
      } finally { busy = false; }
    }
    function createView() {
      if (viewCreated || !allowed || !config.landing || !w.crypto || !w.crypto.randomUUID) return;
      viewCreated = true;
      var current = currentRecord(), now = Date.now();
      var queue = storageRead(KEY + '_views') || [];
      queue = Array.isArray(queue) ? queue.filter(function (e) { return Date.parse(e.created_at) > now - TTL; }).slice(-49) : [];
      queue.push({ schema_version: 1, event_type: 'partner_landing_viewed', merchant_id: 'yahyah',
        event_id: w.crypto.randomUUID(), created_at: new Date(now).toISOString(),
        partner_click_id: current && current.values.partner_click_id || null,
        portrait_id: current && current.values.portrait_id || null,
        page_url: w.location.origin + w.location.pathname });
      storageWrite(KEY + '_views', queue);
      // No endpoint is configured during preparation. Do not fabricate deliveries or send to MSS directly.
    }
    function bindConsentButtons() {
      d.querySelectorAll('[data-mss-allow]').forEach(function (button) {
        button.addEventListener('click', function () {
          var p = privacy(); if (!p) { setStatus('consent_unavailable'); return; }
          p.setTrackingConsent({ analytics: true, marketing: true }, function () { refreshConsent(); });
        });
      });
      d.querySelectorAll('[data-mss-decline]').forEach(function (button) {
        button.addEventListener('click', function () {
          var p = privacy(); if (!p) { setStatus('consent_unavailable'); return; }
          p.setTrackingConsent({ analytics: false, marketing: false }, function () {
            refreshConsent(); sync().catch(function () { setStatus('consent_not_granted'); });
          });
        });
      });
      setStatus(status);
    }
    d.addEventListener('visitorConsentCollected', refreshConsent);
    if (privacy()) refreshConsent();
    else if (w.Shopify && w.Shopify.loadFeatures) {
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { refreshConsent(); });
    }
    w.setTimeout(function () { if (status === 'waiting_for_consent') { setStatus('consent_unavailable'); readyResolve(); } }, 5000);
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', bindConsentButtons, { once: true });
    else bindConsentButtons();
    w.YahyahMSS = { checkout: checkout, sync: sync };
    return w.YahyahMSS;
  }
  return { clean: clean, resolve: resolve, attributes: attributes, install: install, TTL: TTL };
});
